enum enOrderStepType {
    Load = "Load",
    Unload = "Unload"
}

export default enOrderStepType;
